export default function NoteIcon() {
  return (
    <svg
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      height={16}
      width={16}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 2v4"></path>
      <path d="M12 2v4"></path>
      <path d="M16 2v4"></path>
      <rect width="16" height="18" x="4" y="4" rx="2"></rect>
      <path d="M8 10h6"></path>
      <path d="M8 14h8"></path>
      <path d="M8 18h5"></path>
    </svg>
  );
}
